import { Link } from "react-router-dom";

export default function Logo({ small = false }) {
  return (
    <Link
      to="/"
      data-testid="brand-logo"
      className="flex items-center gap-3 group"
    >
      <span className="relative">
        <svg
          width={small ? "28" : "34"}
          height={small ? "28" : "34"}
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="transition-transform duration-500 group-hover:rotate-12"
        >
          <path
            d="M8 32 L20 6 L32 32 M14 22 L26 22"
            stroke="#D4AF37"
            strokeWidth="2.2"
            strokeLinecap="square"
            strokeLinejoin="miter"
          />
          <circle cx="32" cy="8" r="1.6" fill="#D4AF37" />
        </svg>
      </span>
      <div className="leading-none">
        <div
          className={`font-display font-medium tracking-tight ${small ? "text-base" : "text-lg"}`}
        >
          Elevara
        </div>
        <div className="text-[9px] uppercase tracking-[0.28em] text-[#D4AF37]/80 mt-0.5">
          by Innapax
        </div>
      </div>
    </Link>
  );
}
